<template>
  <div class="dashboard-meeting">
    <div class="page-header">
      <div class="page-header-title">
        会议
      </div>
      <div class="page-header-subinfo">
        <!-- <div>
          <i class="iconfont icon-huiyizhihangkanban"></i>会议执行看板
        </div> -->

      </div>
    </div>
    <div class="page-contain">
      <div class="search-content-main">
          <el-form class="search-content-main-fields">
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.year" @change="handleMainSearch()">
                    <el-option v-for="item in baseDataRecords.Year" :key="item.id" :value="item.id" :label="item.yearName">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select multiple class="search-content-main-fields" placeholder="请选择" v-model="seasonArr" @change="handleMainSearch()">
                    <el-option value="" label="全部季度"></el-option>
                    <el-option v-for="item of 4" :key="item" :value="item" :label="'第'+item+'季'">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select multiple class="search-content-main-fields" placeholder="请选择" v-model="monthArr" @change="handleMainSearch()">
                    <el-option value="" label="全部月份"></el-option>
                    <el-option v-for="item of 12" :key="item" :value="item" :label="item+'月'">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingSystem" @change="handleMainSearch()">
                    <el-option value="" label="全部系统"></el-option>
                    <el-option v-for="item in baseDataRecords.MeetingSystem" :key="item.value" :value="item.value" :label="item.text">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.departId" @change="medicalFieldArr=[''];teamFieldArr=[''];strategyKeynoteArr=[''];handleMainSearch()">
                    <el-option value="" label="全部部门"></el-option>
                    <el-option v-for="item in baseDataRecords.Depart" :key="item.id" :value="item.id" :label="item.departName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select multiple class="search-content-main-fields" placeholder="请选择" v-model="medicalFieldArr" @change="teamFieldArr=[''];strategyKeynoteArr=[''];handleMainSearch()">
                    <el-option value="" label="全部Franchise/DA"></el-option>
                    <el-option v-for="item in getMedicalFieldArray(searchMainData.departId, true)" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                    </el-option>
                  </el-select>
              </el-form-item>
            <el-form-item>
              <el-select multiple class="search-content-main-fields" placeholder="请选择" v-model="teamFieldArr" @change="handleMainSearch()">
                <el-option value="" label="全部团队"></el-option>
                <el-option v-for="item in getTeamArray(searchMainData.departId, medicalFieldArr, true)" :key="item.id" :value="item.id" :label="item.teamName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form class="search-content-main-fields">
              <el-form-item>
                  <el-select multiple filterable class="search-content-main-fields" placeholder="请选择（可搜索）" v-model="productIdArr" @change="strategyKeynoteArr=[''];handleMainSearch()">
                    <el-option value="" label="全部产品"></el-option>
                    <el-option v-for="item in baseDataRecords.Product" :key="item.id" :value="item.id" :label="item.productName">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select multiple filterable class="search-content-main-fields" placeholder="请选择（可搜索）" v-model="strategyKeynoteArr" @change="handleMainSearch()">
                    <el-option value="" label="全部策略重点"></el-option>
                    <el-option v-for="item in filterStrategy" :key="item.id" :value="item.id" :label="item.keynote">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingModality" @change="handleMainSearch()">
                    <el-option value="" label="全部会议形式"></el-option>
                    <el-option v-for="item in baseDataRecords.MeetingModality" :key="item.value" :value="item.value" :label="item.text">
                    </el-option>
                  </el-select>
              </el-form-item>
            <el-form-item>
              <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingProp" @change="searchMainData.meetingType='';handleMainSearch()">
                <el-option value="" label="全部会议性质"></el-option>
                <el-option v-for="item in meetingPropAndTypeArrays.selectMeetingProp" :key="item.itemValue" :value="item.itemValue" :label="item.itemText">
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingType" @change="handleMainSearch()">
                    <el-option value="" label="全部A1会议类型"></el-option>
                    <el-option v-for="item in filterMeetingType" :key="item.itemValue" :value="item.itemValue" :label="item.itemText">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingGsdType" @change="handleMainSearch()">
                    <el-option value="" label="全部GSD项目类型"></el-option>
                    <el-option v-for="item in baseDataRecords.MeetingGsdType" :key="item.value" :value="item.value" :label="item.text">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-select class="search-content-main-fields" placeholder="请选择" v-model="searchMainData.meetingGsdSubType" @change="handleMainSearch()">
                    <el-option value="" label="全部GSD细项"></el-option>
                    <el-option v-for="item in MeetingGsdSubTypes" :key="item.value" :value="item.value" :label="item.text">
                    </el-option>
                  </el-select>
              </el-form-item>
          </el-form>
      </div>
      <div class="search-content-other">
        <div class="search-content-other-rate-types">
          <div class="search-content-other-rate-types-item" :class="searchMainData.planRateType == '1'?'active':''" @click="searchMainData.planRateType = '1';handleMainSearch()">策略重点</div>
          <div class="search-content-other-rate-types-item" :class="searchMainData.planRateType == '2'?'active':''" @click="searchMainData.planRateType = '2';handleMainSearch()">会议形式</div>
          <div class="search-content-other-rate-types-item" :class="searchMainData.planRateType == '3'?'active':''" @click="searchMainData.planRateType = '3';handleMainSearch()">会议类型</div>
        </div>
        <div class="search-content-other-distribute-types">
          <div class="search-content-other-distribute-types-item" :class="searchMainData.distributeType == '1'?'active':''" @click="searchMainData.distributeType = '1';handleMainSearch()">场次</div>
          <div class="search-content-other-distribute-types-item" :class="searchMainData.distributeType == '2'?'active':''" @click="searchMainData.distributeType = '2';handleMainSearch()">预算</div>
        </div>
      </div>
      <div class="charts-row">
        <div class="chart" v-show="searchMainData.planRateType == '1'">
          <div class="title"><i class="iconfont icon-celvejihuazhanbi"></i>策略计划占比</div>
          <div>
            <common-echars
              chartClass="chart-class-1"
              :dataset-dimensions="['类型','占比']"
              :dataset-source="data1"
              :option="option1"
              ref="chart1"
            >
            </common-echars>
          </div>
        </div>
        <div class="chart" v-show="searchMainData.planRateType != '1'">
          <div class="title"><i class="iconfont icon-huiyijihuazhanbi"></i>会议计划占比</div>
          <div>
            <common-echars
              chartClass="chart-class-2"
              :dataset-dimensions="['类型','占比']"
              :dataset-source="data2"
              :option="option2"
              ref="chart2"
            >
            </common-echars>
          </div>
        </div>
        <div class="chart chart-right">
          <div class="title"><i class="iconfont" :class="searchMainData.planRateType == '1'?'icon-celvezhihangjindu':'icon-huiyizhihangjindu'"></i>{{searchMainData.planRateType == '1'?'策略':'会议'}}执行进度</div>
          <div>
            <common-echars
              chartClass="chart-class-3"
              :dataset-dimensions="dimensions3"
              :dataset-source="data3"
              :option="option3"
              ref="chart3"
            >
            </common-echars>
          </div>
        </div>
      </div>
      <div class="charts-row">
        <div class="search-content-trend">
          <div class="search-content-trend-item" :class="searchMainData.selectMeetingStatus == '1'?'active':''" @click="searchMainData.selectMeetingStatus = '1';handleMainSearch(true)">
            已计划
          </div>
          <div class="search-content-trend-item" :class="searchMainData.selectMeetingStatus == '3'?'active':''" @click="searchMainData.selectMeetingStatus = '3';handleMainSearch(true)">
            已执行
          </div>
          <div class="search-content-trend-item" :class="searchMainData.selectMeetingStatus == '2'?'active':''" @click="searchMainData.selectMeetingStatus = '2';handleMainSearch(true)">
            待执行
          </div>
          <div v-if="searchMainData.planRateType != '1'" class="search-content-trend-item" :class="searchMainData.selectMeetingStatus == '4'?'active':''" @click="searchMainData.selectMeetingStatus = '4';handleMainSearch(true)">
            计划外
          </div>
        </div>
        <div class="chart chart-full">
          <div class="title"><i class="iconfont" :class="searchMainData.planRateType == '1'?'icon-celveyueduqushi':'icon-huiyiyueduqushi'"></i>{{searchMainData.planRateType == '1'?'策略':'会议'}}月度趋势</div>
          <div>
            <common-echars
              chartClass="chart-class-4"
              :dataset-dimensions="dimensions4"
              :dataset-source="source4"
              :option="option4"
              ref="chart4"
            >
            </common-echars>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dashboardApi from '@/api/dashboard/index';
import application from '@/api/meetingplan/application';
import { mapGetters, mapActions } from 'vuex';
import * as orgUtil from '@/util/organizationUtil'

export default {
  data() {
    return {
      seasonArr: [''],
      monthArr: [''],
      medicalFieldArr: [''],
      teamFieldArr: [''],
      productIdArr: [''],
      strategyKeynoteArr: [''],
      searchMainData: {
        year: '',
        seasonList: '',
        monthList: '',
        meetingSystem: '',
        departId: '',
        medicalFieldList: '',
        teamFieldList: '',
        productIdList: '',
        strategyKeynoteList: '',
        meetingModality: '',
        meetingType: '',
        meetingGsdType: '',
        meetingGsdSubType: '',
        meetingProp: '',
        planRateType: '',
        distributeType: '',
        selectMeetingStatus: '',
      },
      meetingPropAndTypeArrays: {
        selectMeetingProp:[], //可选的会议性质
        popMeetingType:[], //推广的会议类型绑定
        nopopMeetingType: [], //非推广的会议类型绑定
        meetingPropType: [] //推广+非推广的会议类型绑定
      },
      //1、策略计划占比
      data1: [],
      option1: {
          color:['rgba(45, 130, 240, 0.65)','rgba(23, 178, 251, 0.65)','rgba(14, 199, 113, 0.65)','rgba(255, 181, 42, 0.65)','rgba(255, 133, 33, 0.65)','rgba(251, 48, 77, 0.65)','rgba(149, 93, 243, 0.65)','rgba(100, 116, 147, 0.65)'],
          tooltip: { 
            trigger: 'item' ,
            formatter: this.percentFormater
          },
          series: [
          {
              type:'pie',
              label: {
                show: true,
                formatter: function(params) {
                  let html = '';
                  html += params.name+'\n';
                  html += params.percent+'%';
                  return html;
                }
              }
            },
          ]
      },
      data1Remain: 100,
      data2Remain: 100,
      //2、会议计划占比
      data2: [],
      option2: {
          color:['rgba(45, 130, 240, 0.65)','rgba(23, 178, 251, 0.65)','rgba(14, 199, 113, 0.65)','rgba(255, 181, 42, 0.65)','rgba(255, 133, 33, 0.65)','rgba(251, 48, 77, 0.65)','rgba(149, 93, 243, 0.65)','rgba(100, 116, 147, 0.65)'],
          tooltip: { 
            trigger: 'item',
            formatter: this.percentFormater 
          },
          series: [
            {
              type:'pie',
              label: {
                show: true,
                formatter: function(params) {
                  let html = '';
                  html += params.name+'\n';
                  html += params.percent+'%';
                  return html;
                }
              }
            },
          ]
      },
      //3、执行进度
      data3: [],
      option3: {
        grid: {
          left: 80,
          right: 25
        },
        color:[],
        legend: {
          data: [],
          icon: 'rect',
          left: 0,
          itemWidth: 8,
          itemHeight: 8
        },
        tooltip: {
          trigger: 'item' ,
          formatter: this.progressFormater
        },
        xAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            overflow: 'truncate',
            ellipsis: '...',
            width: 60,
            fontSize: 10
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
        },
        series: []
      },
      //4、月度趋势
      data4: {
            "strategyNames": [
            ],
            "data": [
            ]
        },
      option4: {
        color:['rgba(45, 130, 240, 0.65)','rgba(23, 178, 251, 0.65)','rgba(14, 199, 113, 0.65)','rgba(255, 181, 42, 0.65)','rgba(255, 133, 33, 0.65)','rgba(251, 48, 77, 0.65)','rgba(149, 93, 243, 0.65)','rgba(100, 116, 147, 0.65)'],
        legend: {
          icon: 'rect',
          left: -4,
          padding: [5,300,5,5],
          itemWidth: 8,
          itemHeight: 4
        },
        tooltip: {
          trigger: 'axis' ,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
          },
          formatter: this.trendFormater
        },
        xAxis: {type: 'category'},
        yAxis: {
          axisLabel: {
            formatter: this.formatLabelValue
          }
        },
        series: []
      },
    }
  },
  watch: {
    'medicalFieldArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'medicalFieldArr');
    },
    'teamFieldArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'teamFieldArr');
    },
    'productIdArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'productIdArr');
    },
    'strategyKeynoteArr'(newVal, oldVal) {
      this.do(newVal, oldVal, 'strategyKeynoteArr');
    },
    'seasonArr'(newVal, oldVal) {
      if (oldVal.indexOf('') >= 0 && (newVal.indexOf('') >= 0 && newVal.length > 1)) {
        this.seasonArr.splice(this.seasonArr.indexOf(''), 1);
      } else if (oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0) {
        this.seasonArr = [''];
      }
    },
    'monthArr'(newVal, oldVal) {
      if (oldVal.indexOf('') >= 0 && (newVal.indexOf('') >= 0 && newVal.length > 1)) {
        this.monthArr.splice(this.monthArr.indexOf(''), 1);
      } else if (oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0) {
        this.monthArr = [''];
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords','basedataGetName','basedataGetNameByRowIdField']),
    MeetingGsdSubTypes() {
      return this.baseDataRecords['MeetingGsdTypeSub' + this.searchMainData.meetingGsdType] || [];
    },
    filterMeetingType() {
        if(!this.searchMainData.meetingProp) {
            let tempAll = [];
            if(JSON.stringify(this.meetingPropAndTypeArrays) !== '{}') {
              this.meetingPropAndTypeArrays.popMeetingType.forEach(m => {
                if(!tempAll.some(t => t.itemValue == m.itemValue)) {
                  tempAll.push(m);
                }
              })
              this.meetingPropAndTypeArrays.nopopMeetingType.forEach(m => {
                if(!tempAll.some(t => t.itemValue == m.itemValue)) {
                  tempAll.push(m);
                }
              })
              this.meetingPropAndTypeArrays.meetingPropType.forEach(m => {
                if(!tempAll.some(t => t.itemValue == m.itemValue)) {
                  tempAll.push(m);
                }
              })
            }
            return tempAll;
        }
        switch(this.basedataGetName('MeetingProp',this.searchMainData.meetingProp)) {
            case '推广':
                return this.meetingPropAndTypeArrays.popMeetingType;
            case '非推广':
                return this.meetingPropAndTypeArrays.nopopMeetingType;
            default:
                return this.meetingPropAndTypeArrays.meetingPropType;
        }
    },
    dimensions4() {
      this.option4.series = [];
      for (let index = 0; index < this.data4.strategyNames.length; index++) {
        this.option4.series.push({type:'line'})
      }
      let dimensions = _.clone(this.data4.strategyNames);
      dimensions.unshift('月度');
      return dimensions;
    },
    color3() {
      return this.searchMainData.planRateType != '1'?[
        'rgba(11, 65, 205, 0.65)','rgba(11, 65, 205, 0.5)','rgba(11, 65, 205, 0.35)','rgba(11, 65, 205, 0.8)'
      ]:[
        'rgba(11, 65, 205, 0.65)','rgba(11, 65, 205, 0.5)','rgba(11, 65, 205, 0.8)'
      ]
    },
    legendData3() {
      return this.searchMainData.planRateType != '1'?['名称','已计划','已执行','待执行','计划外']:['名称','已计划','已执行','待执行']
    },
    series3() {
      return this.searchMainData.planRateType != '1'?[
          {type:'bar',label:{show:true,position:'insideRight',formatter: this.formatChartValue},stack:'detail',name:'已执行',encode: {x: '已执行',y: '名称'}},
          {type:'bar',label:{show:true,position:'insideRight',formatter: this.formatChartValue},stack:'detail',name:'待执行',encode: {x: '待执行',y: '名称'}},
          {type:'bar',label:{show:true,position:'insideRight',formatter: this.formatChartValue},stack:'detail',name:'计划外',encode: {x: '计划外',y: '名称'}},
          {type:'bar',label:{show:true,position:'insideRight',formatter: this.formatChartValue},name:'已计划',encode: {x: '已计划',y: '名称'}},
        ]:[
          {type:'bar',label:{show:true,position:'insideRight',formatter: this.formatChartValue},stack:'detail',name:'已执行',encode: {x: '已执行',y: '名称'}},
          {type:'bar',label:{show:true,position:'insideRight',formatter: this.formatChartValue},stack:'detail',name:'待执行',encode: {x: '待执行',y: '名称'}},
          {type:'bar',label:{show:true,position:'insideRight',formatter: this.formatChartValue},name:'已计划',encode: {x: '已计划',y: '名称'}},
        ]
    },
    dimensions3() {
      return this.searchMainData.planRateType != '1'?['名称','已执行','待执行','计划外','已计划']:['名称','已执行','待执行','已计划']
    },
    source4() {
      return this.data4.data;
    },
    dimensions1() {
      this.option1.series = [];
      for (let index = 0; index < this.data1.strategyNames.length; index++) {
        this.option1.series.push(this.data1.seriesTemplate);
      }
      let dimensions = _.clone(this.data1.strategyNames);
      dimensions.unshift('策略名');
      return dimensions;
    },
    source1() {
      return this.data1.data;
    },
    filterStrategy() {
        let temp = [];
        let productIds = this.productIdArr;
        this.baseDataRecords.Strategy.forEach(strategy => {
            if (this.searchMainData.departId && this.searchMainData.departId != strategy.departId) {
                return;
            }
            // if(this.searchMainData.medicalField && this.searchMainData.medicalField != strategy.medicalField){
            //     return;
            // }
            if (!productIds || productIds.length == 0 || productIds.indexOf('') == 0) {
              temp.push(strategy);
              return;
            }
            if (productIds && productIds.indexOf(strategy.productId) < 0) {
                return;
            }
            temp.push(strategy);
        })

        return temp;
    },
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalFieldArray, independ) {
      return orgUtil.teamArrayByArray(departId, medicalFieldArray, independ);
    },
    do(newVal, oldVal, field) {
      if (oldVal.indexOf('') >= 0 && (newVal.indexOf('') >= 0 && newVal.length > 1)) {
        this[field].splice(this[field].indexOf(''), 1);
      } else if ((oldVal.indexOf('') < 0 && newVal.indexOf('') >= 0) || newVal.length == 0) {
        this[field] = [''];
      }
    },
    formatLabelValue(value) {
      if(this.searchMainData.distributeType == '1') {
        return value;
      }
      else {
        return this.$toThousand(value) + ' K';
      }
    },
    formatChartValue(params) {
      console.log(params)
      if(!params.value[params.seriesName]) {
        return '';
      }
      else {
        if(parseFloat(params.value[params.seriesName]) == 0) {
          return '';
        }
      }

      if(this.searchMainData.distributeType == '1') {
        return params.value[params.seriesName];
      }
      else {
        return this.$toThousand(params.value[params.seriesName],1,0);
      }
    },
    percentFormater(params) {
      let str = '';
      str += params.seriesName + '<br/>'
      if(this.searchMainData.distributeType == '1') {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + params.value['占比'] + '场</span>';
      }
      else {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + this.$formatMoney(this.$toThousand(params.value['占比'],1,2)) + ' K</span>';
      }
      return str;
    },
    progressFormater(params) {
      let str = '';
      str += params.seriesName + '<br/>'
      if(this.searchMainData.distributeType == '1') {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + params.value[params.seriesName] + '场</span>';
      }
      else {
        str += params.marker + params.name + ' : 　<span style="font-weight:bold">' + this.$formatMoney(this.$toThousand(params.value[params.seriesName],1,2)) + ' K</span>';
      }
      return str;
    },
    trendFormater(params) {
      if(params.length > 0) {
        let dataObj = params[0].data;
        let str = '';
        for(var field in dataObj) {
            if(field != '月度') {
              if(this.searchMainData.distributeType == '1') {
                str += '<div style="display:flex"><div style="width:auto;white-space: normal;">' + field + ' : </div>　<span style="font-weight:bold;margin-left: auto;">' + dataObj[field] + '场</span></div>';
              }
              else {
                str += '<div style="display:flex"><div style="width:auto;white-space: normal;">' + field + ' : </div>　<span style="font-weight:bold;margin-left: auto;">' + this.$formatMoney(this.$toThousand(dataObj[field],1,2)) + ' K</span></div>';
              }
            }
        }
        return str;
      }
    },
    trimSpace(array) {
      for (let i = 0; i < array.length; i++) {
        //这里为过滤的值
        if (array[i] == '' || array[i] == null || typeof (array[i]) == "undefined" || array[i] == ' ') {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    handleArrar4All(arrName) {
      if(this[arrName].length > 0 && this[arrName][this[arrName].length-1] == '') {
        this[arrName] = ['']
      }
    },
    handleMainSearch(isAoneExeStatusChange) {
      if(!isAoneExeStatusChange) {
        this.searchMainData.selectMeetingStatus = '1'
      }
      this.option3.color = this.color3;
      this.option3.legend.data = this.legendData3;
      this.option3.series = this.series3;

      this.handleArrar4All('medicalFieldArr')
      this.handleArrar4All('teamFieldArr')
      this.handleArrar4All('productIdArr')
      this.handleArrar4All('strategyKeynoteArr')
      this.handleArrar4All('seasonArr')
      this.handleArrar4All('monthArr')
      this.searchMainData.medicalFieldList = this.trimSpace(JSON.parse(JSON.stringify(this.medicalFieldArr))).toString();
      this.searchMainData.teamFieldList = this.trimSpace(JSON.parse(JSON.stringify(this.teamFieldArr))).toString();
      this.searchMainData.productIdList = this.trimSpace(JSON.parse(JSON.stringify(this.productIdArr))).toString();
      this.searchMainData.strategyKeynoteList = this.trimSpace(JSON.parse(JSON.stringify(this.strategyKeynoteArr))).toString();
      this.searchMainData.seasonList = this.trimSpace(JSON.parse(JSON.stringify(this.seasonArr))).toString();
      this.searchMainData.monthList = this.trimSpace(JSON.parse(JSON.stringify(this.monthArr))).toString();
      dashboardApi.meeting(this.searchMainData)
          .then(res => {
            if(!isAoneExeStatusChange) {
              this.data1 = [];
              if(res.planPropList){
                res.planPropList.forEach(el => {
                  this.data1.push({
                    '类型':el.name,
                    '占比': el.rate,
                  })
                })
              };

              this.data2 = [];
              if(res.planPropList){
                res.planPropList.forEach(el => {
                  this.data2.push({
                    '类型':el.name,
                    '占比': el.rate,
                  })
                })
              }
              this.data3 = [];
              if(res.rateOfProgressList){
                res.rateOfProgressList.forEach(el => {
                  if(this.searchMainData.planRateType != '1') {
                    this.data3.push({
                      '名称':el['name'],
                      '已计划': el['已计划'],
                      '已执行': el['已执行'],
                      '待执行': el['待执行'],
                      '计划外': el['计划外'],
                    })
                  }
                  else {
                    this.data3.push({
                      '名称':el['name'],
                      '已计划': el['已计划'],
                      '已执行': el['已执行'],
                      '待执行': el['待执行'],
                    })
                  }
                })
              };
            }

            this.data4.strategyNames = [];
            this.data4.data = [];

            if(res.meetingMonthTrendModel
                && res.meetingMonthTrendModel.names
                && res.meetingMonthTrendModel.monthTrend){
                this.data4.strategyNames = res.meetingMonthTrendModel.names;

                res.meetingMonthTrendModel.monthTrend.forEach(el => {
                  el['月度'] = el['month'];
                  delete el['month'];
                })
                this.data4.data = res.meetingMonthTrendModel.monthTrend;
            };

             this.$nextTick(() => {
                if(!isAoneExeStatusChange) {
                  this.$refs['chart1'].chartChange();
                  this.$refs['chart2'].chartChange();
                  this.$refs['chart3'].chartChange();
                }
                this.$refs['chart4'].chartChange();
             });
          })
    },
  },
  mounted() {
    this.searchMainData.year = (new Date()).getFullYear();
    this.searchMainData.planRateType = '1';
    this.searchMainData.distributeType = '1';
    this.searchMainData.selectMeetingStatus = '1';

    this.initBaseDataByTypes(['Organization','Depart','MedicalField','Product','Year', 'MeetingSystem', 'Strategy','MeetingModality','MeetingType','MeetingProp','MeetingGsdType','MeetingGsdTypeSub1','MeetingGsdTypeSub2','MeetingGsdTypeSub3'])
        .then(() => {
          application.queryMeetingPropAndTypeSelect()
                  .then(res => {
                    this.meetingPropAndTypeArrays = res;

                    // if(this.baseDataRecords.Depart.length > 0) {
                    //     this.searchMainData.departId = this.baseDataRecords.Depart[0].id;
                    // }
                    // if(this.baseDataRecords.Organization && this.baseDataRecords.Organization[0][this.searchMainData.departId].length > 0) {
                    //     this.searchMainData.medicalField = this.baseDataRecords.Organization[0][this.searchMainData.departId][0].id;
                    // }
                    // if(this.baseDataRecords.Product.length > 0) {
                    //     this.productIdArr.push(this.baseDataRecords.Product[0].id);
                    // }
                    this.handleMainSearch();
                  })
        })
    window._self = this;
  }
};
</script>

<style lang="less" scoped>
.page-contain {
  margin-bottom: 20px;
}
  .page-header {
    padding: 8px 0;
    margin-top: -24px;
    font-size: @breadcrumbCurrentFontSize;
    font-weight: bold;
    color: @contentFontColor;
    line-height: 32px;
    height: 48px;
    display: flex;
    align-items: center;

    &-title {
      font-weight: 400;
    }

    &-subinfo {
      height: 32px;
      line-height: 32px;
      margin-left: auto;
      font-weight: 400;
      font-size: 14px;
      color: #0B41CD;
      display: flex;

      i {
        margin-right: 8px;
      }

      &-role {
        width: 180px;

        label {
          margin-right: 10px;
          color: @contentFontColor;
        }

        div {
          width: 120px;
        }
      }
    }
  }

  .search-content-main {
    display: inline-block;
    margin-bottom: 6px;

    .search-content-main-fields {
      float:left;
      display: flex;

      .el-form-item + .el-form-item {
        margin-left: 16px;
      }

      &-year {
        width: 120px;
      }

      &-medicalField {
        width: 180px;
      }
      &-departId {
        width: 180px;
      }
    }

    .search-content-main-fields + .search-content-main-fields {
      margin-top: 6px;
    }
  }

  .search-content-other {
    display: flex;
    height: 56px;
    background: #FFFFFF;
    border-radius: 4px;
    margin-bottom: 16px;
    position: relative;

    &-rate-types {
      display: flex;
      margin-left: 24px;

      &-item {
        line-height: 56px;
        height: 56px;
        font-size: @subSubFontSize;
        color: @subSubFontColor;
        width: 80px;
        text-align: center;
        cursor: pointer;
      }

      &-item.active {
        color: @mainColor;
        border-bottom: 3px solid @mainColor;
      }
    }

    &-distribute-types {
      display: flex;
      height: 32px;
      line-height: 32px;
      width: 128px;
      background-color: rgb(232, 234, 236);
      border-radius: 16px;
      margin-top: 12px;
      position: absolute;
      right: 24px;

      &-item {
        width: 64px;
        height: 32px;
        line-height: 32px;
        font-size: @subSubFontSize;
        color: @subSubFontColor;
        border-radius: 16px;
        text-align: center;
        cursor: pointer;
      }

      &-item.active {
        background-color: @mainColor;
        color: #ffffff;
      }
    }
  }

  .charts-row {
    display: flex;
    position: relative;

    .chart {
      height: 320px;
      width: 592px;
      background: #fff;

      .title {
        color: @subSubFontColor;
        font-size: 18px;
        margin: 15px 0 0 24px;

        i {
          font-size: 16px;
          margin-right: 6px;
          color: rgba(11, 65, 205, 0.5);
        }
      }
    }

    .chart-full {
      width: 100%
    }

    .chart-right {
      margin-left: 16px
    }

    .search-content-trend {
      position: absolute;
      right: 24px;
      top: 52px;
      display: flex;
      z-index: 200;

      &-item {
        width: 60px;
        height: 24px;
        border: 1px solid #999999;

        font-weight: @contentFontWeight;
        color: @contentFontColor;
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        cursor: pointer;
      }

      &-item:first-child {
        border-radius: 4px 0 0 4px;
      }

      &-item:last-child {
        border-radius: 0 4px 4px 0;
      }

      &-item.active {
        border-color: @mainColor;
        color: @mainColor;
      }

      .search-content-trend-item + .search-content-trend-item {
        margin-left: -1px;
      }

      .search-content-trend-item.active + .search-content-trend-item {
        border-left-color: @mainColor;
      }
    }
  }

  .charts-row + .charts-row {
    margin-top: 16px;
  }

  .gauge-legend {
    display: flex;
    margin: 16px 0 0 24px;
    font-size: 12px;
    color: @contentFontColor;

    &-value {
      display: flex;
      margin-right: 12px;
      div{
        height: 9px;
        width: 9px;
        border-radius: 4.5px;
        margin: 2px 8px 0 0;
      }
    }

    &-value-1 {
      div {
        background-color: #2D82F0;
      }
    }

    &-value-2 {
      div {
        background-color: #E8EAEC;
      }
    }

    &-value-3 {
      div {
        background-color: #0B41CD;
      }
    }
  }

  .axis-label {
    height: 0px;
    &-0 {
      position: relative;
      top: 145px;
      left: 75px;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
    &-100 {
      position: relative;
      top: 145px;
      left: 195px;
      font-size: 14px;
      color: rgba(0,0,0,0.45);
    }
    &-remain {
      position: relative;
      top: 115px;
      left: 170px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      width: 36px;
    }
  }

  .message-info {
    margin-top: -35px;
    display: flex;
    height: 40px;
    font-size: 12px;
    color: @subFontColor;
    line-height: 20px;
    div {
      margin: 0 auto;
    }
  }

</style>

<style lang="less">
.search-content-main-fields{
  .el-tag--info {
    max-width: 115px;
    min-width: 45px;
    padding-right: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative;
    .el-tag__close{
      position: absolute;
      right: -1px;
      top: 5px;
    }
  }
}
  .dashboard-meeting {
      .chart-class-1 {
          margin-top: 15px;
          margin-left: auto;
          width: 573px;
          height: 280px;
      }
      .chart-class-2{
          margin-top: 15px;
          margin-left: auto;
          width: 572px;
          height: 280px;
      }

      .chart-class-3 {
          margin-top: 15px;
          margin-left: auto;
          width: 572px;
          height: 280px;
      }

      .chart-class-4 {
          margin: 16px 24px;
          height: 300px;
          width: 100%;
      }
  }
</style>



// WEBPACK FOOTER //
// index-old.vue?942634d0